export const transformMeetingObjectives = (objectives = [], type = 'team') => {
  const filteredObjectives = objectives.filter(objective => objective.type === type);
  const totalCount = filteredObjectives.length;
  const set = new Set();
  let sliceIndexEnd = 0;

  const transformed =  filteredObjectives.reduce((acc, curr, index) => {
    sliceIndexEnd = index <= 10 ? [...set].length : sliceIndexEnd;
    if(!set.has(curr.teamName)) {
      set.add(curr.teamName);
      acc.push({[curr.teamName]: [curr]});
    } else {
      acc.forEach((team) => {
        const key = Object.keys(team)[0];
        if(key === curr.teamName) {
          team[key].push(curr);
        }
      });
    }
    return acc;
  },[]);
  return {transformed, filteredObjectives, sliceIndexEnd, totalCount};
};

export const LIMIT_PAGE = 10;

export const filterObjectivesByType = (objectives = [], type = '') => {
  let filteredObjectives = [];
  if (type === '') {
    filteredObjectives = objectives;
  } else {
    filteredObjectives = objectives.filter(objective => objective.type === type);
  }
  const totalCount = filteredObjectives.length;
  let sliceIndexEnd = totalCount > LIMIT_PAGE ? LIMIT_PAGE : totalCount;

  return { filteredObjectives, sliceIndexEnd };
}
